import { createContext } from "react";

export type GlobalContextType = {
  targetMonth: Date;
  setTargetMonth: React.Dispatch<React.SetStateAction<Date>>;
};

const GlobalContext = createContext<GlobalContextType | undefined>(undefined);
export default GlobalContext;